import React from 'react';
import { IntlShape } from 'react-intl';

import { eventTracking } from '@/services/event-tracking';

import { ICard } from '../types';

const createBookCarAppointmentCard = (
  intl: IntlShape,
  links: { requirementsForCar: string; bookCarInspection: string },
): ICard => ({
  id: 'car-book-an-appointment',
  cardStatus: 'todo',
  desc: intl.formatMessage(
    {
      defaultMessage:
        'Confirm <a>vehicle requirements.</a> The car must be inspected at the office.',
      id: 'FqgSlN',
      description: 'todo list card text',
    },
    {
      a: (text: React.ReactNode) => (
        <a href={links.requirementsForCar} target="_blank" rel="noreferrer">
          {text}
        </a>
      ),
    },
  ),
  title: intl.formatMessage({
    defaultMessage: 'book an appointment',
    id: 'BNJ8GD',
    description: 'car screen: todo card',
  }),
  actionTracker: () => {
    eventTracking.track({
      event: 'Onboarding - Car - Inspection - Open',
    });
  },
  actionExternalLink: links.bookCarInspection,
  actionTitle: intl.formatMessage({
    defaultMessage: 'Choose time',
    id: '1XYOF1',
    description: 'car screen: todo card',
  }),
});

export { createBookCarAppointmentCard };
